(function ($) {
  $(window).resize(function() {
    let maxHeight = 0;

    // Find the tallest header
    $('.post-grid-item-container-content').each(function() {
        const thisHeight = $(this).height();
        if (thisHeight > maxHeight) {
            maxHeight = thisHeight;
        }
    });

    // Set all headers to the tallest height
    $('.post-grid-item-container-content').height(maxHeight);
});

// Trigger the resize function initially to set heights on page load
$(window).trigger('resize');

})(jQuery);
